import React from 'react';
import {Sidebar} from '../services/router/configs';

export default function MainLayout({children}: {children: React.ReactNode}) {
  return (
    <>
      {Sidebar && <Sidebar />}
      <div className="main-content">{children}</div>
    </>
  );
}
